import { BASE_URL } from '@/services/api'
import {request, METHOD} from '@/utils/request'
import Cookie from 'js-cookie'


let VIDEO_SAVE= `${BASE_URL}/video/update`,
VIDEO_SAVE_LOG= `${BASE_URL}/video/updatelog`,
VIDEO_CALL_STATUS= `${BASE_URL}/video/getCallStatus`,
VIDEO_RECORD_LIST= `${BASE_URL}/video/getVideoRecordList`,
VIDEO_RECORD_DETAIL= `${BASE_URL}/video/getVideoRecordDetail`,
VIDEO_RECORD_UPDATE= `${BASE_URL}/video/updateVideoRecord`,
VIDEO_RECORD_DELETE= `${BASE_URL}/video/deleteVideoRecord`,
UPLOAD_AUDIO= `${BASE_URL}/video/uploadAudio`,
GET_AUDIO= `${BASE_URL}/video/getAudioList`,
GET_AUDIO_STATUS= `${BASE_URL}/video/getAudioStatus`,
UPLOAD_RECORD_AUDIO= `${BASE_URL}/video/uploadRecordAudio`,
GET_CHECKLIST_TEMPLATE= `${BASE_URL}/video/getCheckListTemplate`,
UPDATE_CHECKLIST_LOG= `${BASE_URL}/video/updateCheckListLog`

export async function saveVideoRecord(params) {
  return request(VIDEO_SAVE, METHOD.POST, params)
}
export async function saveCallLog(params) {
  return request(VIDEO_SAVE_LOG, METHOD.POST, params)
}
export function saveCallLogWithBeacon(params) {
  const payload = JSON.stringify(params || {})
  const accessToken = localStorage.getItem('accessToken')
  const authorization = Cookie.get('Authorization') || (accessToken ? `Bearer ${accessToken}` : '')
  if (typeof fetch !== 'function' || !authorization) {
    return false
  }
  fetch(VIDEO_SAVE_LOG, {
    method: 'POST',
    body: payload,
    headers: {
      'Authorization': authorization,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    credentials: 'same-origin',
    keepalive: true
  }).catch(() => {})
  return true
}
export async function getCallStatus(params) {
  return request(VIDEO_CALL_STATUS, METHOD.POST, params)
}
export async function getVideoRecordList(params) {
  return request(VIDEO_RECORD_LIST, METHOD.POST, params)
}
export async function getVideoRecordDetail(params) {
  return request(VIDEO_RECORD_DETAIL, METHOD.POST, params)
}
export async function updateRecordFlg(params) {
  return request(VIDEO_RECORD_UPDATE, METHOD.POST, params)
}

export async function deleteRecord(params) {
  return request(VIDEO_RECORD_DELETE, METHOD.POST, params)
}

export async function uploadAudio(params) {
  return request(UPLOAD_AUDIO, METHOD.POST,params,{
    headers: {'Content-Type': 'multipart/form-data'}
  })
}

export async function getAudioStatus(params) {
  return request(GET_AUDIO_STATUS, METHOD.POST, params)
}
export async function getAudioList(params) {
  return request(GET_AUDIO, METHOD.POST, params)
}

export async function uploadRecordAudio(params) {
  return request(UPLOAD_RECORD_AUDIO, METHOD.POST,params,{
    headers: {'Content-Type': 'multipart/form-data'}
  })
}

export async function getCheckListTemplate(params) {
  return request(GET_CHECKLIST_TEMPLATE, METHOD.POST, params)
}
export async function updateCheckListLog(params) {
  return request(UPDATE_CHECKLIST_LOG, METHOD.POST, params)
}

export default {
  saveVideoRecord,
  saveCallLog,
  saveCallLogWithBeacon,
  getCallStatus,
  getVideoRecordList,
  updateRecordFlg,
  deleteRecord,
  uploadAudio,
  uploadRecordAudio,
  getCheckListTemplate,
  updateCheckListLog,
}
